import classNames from 'classnames';
import React from 'react';
import * as styles from './PopOverArrow.module.scss';
import PopOverPrimitive from './PopOverPrimitive';

interface PopOverArrowProps {
  className?: string;
}

const PopOverArrow = ({ className }: PopOverArrowProps) => {
  return (
    <PopOverPrimitive.Arrow
      height={10}
      width={18}
      offset={1.8}
      viewBox="0 0 18 10"
      className={className}
    >
      <path
        className={styles.arrowBg}
        d="M9.95385 1.71898L17 10L1 10L8.53945 1.69616C8.93627 1.31174 9.56964 1.32196 9.95385 1.71898Z"
      />

      <path
        clipPath='path("M 0 9 L 18 9 L 18 -1 L 0 -1")'
        className={classNames(styles.arrowBg, styles.arrowStroke)}
        d="M17 9L9.95385 1.71898C9.56964 1.32196 8.93627 1.31174 8.53945 1.69616L1 9"
      />
    </PopOverPrimitive.Arrow>
  );
};

export default PopOverArrow;
